import { OnInit, Component, Input, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ModuleType } from "@enums/ModuleType";
import { PeriodicNotificationModel } from "@app/mailmessages/models/periodicNotificationModel";
import { PeriodicNotificationService } from "@app/mailmessages/service/periodic-notification.service";
import { IncidentPeriodicNotificationService } from "@app/incident/services/incident-periodicnotification.service";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/mailmessages/i18n/scope";

@Component({
    selector: "uc-periodic-notification-overview",
    templateUrl: "./periodic-notification-overview.component.html",
    styleUrls: ["./periodic-notification-overview.component.scss"],
    imports: [GenericListManagerComponent],
})
export class PeriodicNotificationOverviewComponent implements OnInit {
    private _tabService = inject(TabService);
    private _pnService = inject(PeriodicNotificationService);
    private _incidentService = inject(IncidentPeriodicNotificationService);
    private _translation = injectTranslation(scope);
    pages = inject(Pages);

    @Input() module: ModuleType;

    config: GenericListConfig;

    // Await the scope before the synchronous t() calls in setupConfig().
    async ngOnInit() {
        await this._translation.ready();
        if (this.module === ModuleType.Incidents) {
            this._incidentService.getIncidentNotifications().subscribe((data) => {
                for (let i = 0; i < data.length; i++) {
                    data[i].moduleType = ModuleType.Incidents;
                }
                this.setupConfig(data);
            });
        } else {
            this._pnService.getNotifications(this.module).subscribe((data) => {
                this.setupConfig(data);
            });
        }
    }

    setupConfig(data: PeriodicNotificationModel[]) {
        this.config = <GenericListConfig>{
            name: this._translation.t("periodicOverview.listName"),
            data: data,
            idProp: "id",

            allowAdd: true,
            allowEdit: true,
            allowDelete: false,

            fields: [
                {
                    fieldName: "name",
                    prettyName: this._translation.t("periodicOverview.nameField"),
                    fieldType: GenericListFieldType.Text,
                    isReadonly: true,
                },
                {
                    fieldName: "subject",
                    prettyName: this._translation.t("periodicOverview.subjectField"),
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: "active",
                    prettyName: this._translation.t("periodicOverview.sendActiveField"),
                    fieldType: GenericListFieldType.CheckBox,
                },
            ],
            addOverride: () => {
                const config = {
                    module: this.module,
                };
                this._tabService.generateTab(
                    this.pages.PeriodicDetail,
                    0,
                    this._translation.t("periodicOverview.newPeriodicNotificationTab"),
                    config
                );
            },
            editOverride: (row: PeriodicNotificationModel) => {
                const config = {
                    module: this.module,
                };
                this._tabService.generateTab(this.pages.PeriodicDetail, row.id, row.name, config);
            },
        };
    }
}
